import type { User } from '../types';
import { hasVmsRole, isVmsAdminUser } from './vmsRole';

/** Configure flow stakeholders (list + detail). */
export function canAccessFlowStakeholders(user: User | null | undefined): boolean {
  return hasVmsRole(user, 'business_owner') || isVmsAdminUser(user);
}

export function canManageFlowStakeholders(user: User | null | undefined): boolean {
  return canAccessFlowStakeholders(user);
}
